module.exports = __webpack_public_path__ + "static/guarantee-54aeb7228dd94643e81f99a199a1bb08.svg";